export const server = {
  url: "https://main.digisherpa.ai",
  //   url: "http://localhost:8091",
};
